export default __webpack_public_path__ + "static/media/internacional.4576c72a.svg";